import {useQuery} from '@github-ui/react-query'

import type {CustomAgentType} from '../utils/copilot-chat-types'
import {useChatManager} from '../utils/CopilotChatManagerContext'

export function useCustomAgentsQuery(nwo?: string) {
  const manager = useChatManager()

  const query = useQuery<CustomAgentType[]>({
    enabled: Boolean(nwo),
    queryKey: ['custom-agents', nwo],
    queryFn: async () => {
      if (!nwo) return []

      // Split nwo (name with owner) into owner and repo
      // nwo format is "owner/repo"
      const [owner, repo] = nwo.split('/')
      if (!owner || !repo) return []

      const response = await manager.service.fetchCustomAgents(owner, repo)

      if (!response.ok) {
        return []
      }

      return response.payload
    },
  })

  return query
}
